import { BQSqlFunctionHelper } from 'src/app/utils/datasource-sql-map/bq-sql-function-helper';
import { IDatasourceSQLMap } from 'src/app/utils/datasource-sql-map/datasource';
import { DatasourceSpecificColumnsSQLStatementsCompiler } from 'src/app/utils/datasource-sql-map/datasource-specific-sql-statements-compiler';
import { DatePickerSqlTokensCompiler } from 'src/app/utils/datasource-sql-map/date-picker-sql-tokens-compiler';
import {
    multipleSelectComponentCompileSQLTokens,
    playerIdCompileSQLTokens,
    segmentContainerIdCompileSQLTokens,
} from 'src/app/utils/datasource-sql-map/utils';
import { StringInputFilterDashboardItemComponent } from '../../common/items/filter/string-input-filter/string-input-filter.component';

const DAY_NO_GROUP = `CASE
    WHEN player_day.install_day_no BETWEEN 1 AND 7 THEN CAST(player_day.install_day_no AS STRING)
    WHEN player_day.install_day_no BETWEEN 8 AND 14 THEN '8-14'
    WHEN player_day.install_day_no BETWEEN 15 AND 29 THEN '15-29'
    WHEN player_day.install_day_no >= 30 THEN '30+'
    ELSE CAST(player_day.install_day_no AS STRING)
END`;

export class BiVizDashboardResourcesSqlMap {
    public static sqlMap: IDatasourceSQLMap = {
        //dataset: 'bi_dev',
        // TODO replace in final version
        dataset: 'bi_viz',
        tableId: 'dashboard_resources',
        columns: {
            ACTIVITY_DATE: {
                columnId: 'ACTIVITY_DATE',
                columnSQL: 'date',
                compileSQLTokens: (state) => {
                    return DatePickerSqlTokensCompiler.compileTokens(
                        'date',
                        state
                    );
                },
            },
            PLAYER_ID: {
                columnId: 'PLAYER_ID',
                columnSQL: 'player_id',
                compileSQLTokens: (state) => {
                    return playerIdCompileSQLTokens('player_id', state);
                },
            },
            ACTIVITY_APP_VERSION: {
                columnId: 'ACTIVITY_APP_VERSION',
                columnSQL: 'player_day.daily_app_version',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_day.daily_app_version',
                        state
                    );
                },
            },
            ACTIVITY_APP_VERSION_GROUP_MINOR: {
                columnId: 'ACTIVITY_APP_VERSION_GROUP_MINOR',
                columnSQL: `${BQSqlFunctionHelper.getCallSqlStatement(
                    BQSqlFunctionHelper.VERSION_HIERARCHY,
                    ['player_day.daily_app_version']
                )}.minor`,
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        `${BQSqlFunctionHelper.getCallSqlStatement(
                            BQSqlFunctionHelper.VERSION_HIERARCHY,
                            ['player_day.daily_app_version']
                        )}.minor`,
                        state
                    );
                },
            },
            ACTIVITY_DAY_NO: {
                columnId: 'ACTIVITY_DAY_NO',
                columnSQL: 'player_day.day_no',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_day.day_no',
                        state
                    );
                },
            },
            INSTALL_DAY_NO: {
                columnId: 'INSTALL_DAY_NO',
                columnSQL: DAY_NO_GROUP,
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        DAY_NO_GROUP,
                        state
                    );
                },
            },
            // DAILY_AD_CONSENT: {
            //     columnId: 'DAILY_AD_CONSENT',
            //     columnSQL: 'player_day.daily_ad_consent',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'player_day.daily_ad_consent',
            //             state
            //         );
            //     },
            // },
            // DAILY_TOTAL_ENERGY_SPENT: {
            //     columnId: 'DAILY_TOTAL_ENERGY_SPENT',
            //     columnSQL: 'energy_outflow_running_group',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'energy_outflow_running_group',
            //             state
            //         );
            //     },
            // },
            ATTRIBUTION_TRAFFIC_SOURCE: {
                columnId: 'ATTRIBUTION_TRAFFIC_SOURCE',
                columnSQL: 'player_dim.attribution.unified_traffic',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.attribution.unified_traffic',
                        state
                    );
                },
            },
            ATTRIBUTION_NETWORK_NAME: {
                columnId: 'ATTRIBUTION_NETWORK_NAME',
                columnSQL: 'player_dim.attribution.unified_network',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.attribution.unified_network',
                        state
                    );
                },
            },
            ATTRIBUTION_CAMPAIGN_NAME: {
                columnId: 'ATTRIBUTION_CAMPAIGN_NAME',
                columnSQL: 'player_dim.attribution.unified_campaign',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.attribution.unified_campaign',
                        state
                    );
                },
            },
            DECO_CONTEXT_RARITY: {
                columnId: 'DECO_CONTEXT_RARITY',
                columnSQL: 'source_params.ctx_deco_rarity',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'source_params.ctx_deco_rarity',
                        state
                    );
                },
            },
            DECO_CONTEXT_SIZE: {
                columnId: 'DECO_CONTEXT_SIZE',
                columnSQL: 'source_params.ctx_deco_size',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'source_params.ctx_deco_size',
                        state
                    );
                },
            },
            DECO_CONTEXT_SET_ID: {
                columnId: 'DECO_CONTEXT_SET_ID',
                columnSQL: 'source_params.ctx_deco_set_id',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'source_params.ctx_deco_set_id',
                        state
                    );
                },
            },
            DECO_CONTEXT_INSPIRATIONS: {
                columnId: 'DECO_CONTEXT_INSPIRATIONS',
                columnSQL:
                    'CAST(source_params.ctx_deco_inspirations AS STRING)',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'CAST(source_params.ctx_deco_inspirations AS STRING)',
                        state
                    );
                },
            },
            DEVICES_SELECTED_GA_FIRST_DEVICE_MODEL: {
                columnId: 'DEVICES_SELECTED_GA_FIRST_DEVICE_MODEL',
                columnSQL: 'player_dim.device.first_device.model',
                compileSQLTokens: (state) => {
                    return StringInputFilterDashboardItemComponent.compileSqlTokens(
                        'player_dim.device.first_device.model',
                        state
                    );
                },
            },
            ETL_PAYER: {
                columnId: 'ETL_PAYER',
                columnSQL: 'player_dim.revenue_sessions.payer_label',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.revenue_sessions.payer_label',
                        state
                    );
                },
            },
            ETL_REVENUE_BADGE: {
                columnId: 'ETL_REVENUE_BADGE',
                columnSQL: 'player_dim.revenue_sessions.revenue_badge',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.revenue_sessions.revenue_badge',
                        state
                    );
                },
            },
            FIREBASE_APP_STORE: {
                columnId: 'FIREBASE_APP_STORE',
                columnSQL: 'player_dim.revenue_sessions.first_store',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.revenue_sessions.first_store',
                        state
                    );
                },
            },
            FIREBASE_COUNTRY_EUROPEAN_UNION: {
                columnId: 'FIREBASE_COUNTRY_EUROPEAN_UNION',
                columnSQL: 'player_dim.geo.first_geo.country_european_union',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.geo.first_geo.country_european_union',
                        state
                    );
                },
            },
            FIREBASE_COUNTRY_TIER: {
                columnId: 'FIREBASE_COUNTRY_TIER',
                columnSQL: 'player_dim.geo.first_geo.country_tier_label',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.geo.first_geo.country_tier_label',
                        state
                    );
                },
            },
            FIREBASE_COUNTRY_IS_RELEVANT_LABEL: {
                columnId: 'FIREBASE_COUNTRY_IS_RELEVANT_LABEL',
                columnSQL: 'player_dim.geo.first_geo.country_is_relevant_label',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.geo.first_geo.country_is_relevant_label',
                        state
                    );
                },
            },
            FIREBASE_COUNTRY: {
                columnId: 'FIREBASE_COUNTRY',
                columnSQL: 'player_dim.geo.first_geo.unified_country',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.geo.first_geo.unified_country',
                        state
                    );
                },
            },
            FIREBASE_FIRST_OPEN_DATE: {
                columnId: 'FIREBASE_FIRST_OPEN_DATE',
                columnSQL: 'player_dim.revenue_sessions.first_session_date',
                compileSQLTokens: (state) => {
                    return DatePickerSqlTokensCompiler.compileTokens(
                        'player_dim.revenue_sessions.first_session_date',
                        state
                    );
                },
            },
            FIREBASE_INSTALL_VERSION: {
                columnId: 'FIREBASE_INSTALL_VERSION',
                columnSQL: 'player_dim.revenue_sessions.install_version',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.revenue_sessions.install_version',
                        state
                    );
                },
            },
            FIREBASE_INSTALL_VERSION_GROUP_MINOR: {
                columnId: 'FIREBASE_INSTALL_VERSION_GROUP_MINOR',
                columnSQL: `${BQSqlFunctionHelper.getCallSqlStatement(
                    BQSqlFunctionHelper.VERSION_HIERARCHY,
                    ['player_dim.revenue_sessions.install_version']
                )}.minor`,
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        `${BQSqlFunctionHelper.getCallSqlStatement(
                            BQSqlFunctionHelper.VERSION_HIERARCHY,
                            ['player_dim.revenue_sessions.install_version']
                        )}.minor`,
                        state
                    );
                },
            },
            GA_FIRST_DEVICE_BRAND: {
                columnId: 'GA_FIRST_DEVICE_BRAND',
                columnSQL: 'player_dim.device.first_device.unified_brand',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.device.first_device.unified_brand',
                        state
                    );
                },
            },
            GA_FIRST_DEVICE_CATEGORY: {
                columnId: 'GA_FIRST_DEVICE_CATEGORY',
                columnSQL: 'player_dim.device.first_device.category',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.device.first_device.category',
                        state
                    );
                },
            },
            GA_FIRST_DEVICE_MODEL: {
                columnId: 'GA_FIRST_DEVICE_MODEL',
                columnSQL: 'player_dim.device.first_device.model',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'player_dim.device.first_device.model',
                        state
                    );
                },
            },
            RESOURCES_SOURCE: {
                columnId: 'RESOURCES_SOURCE',
                columnSQL: 'source',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'source',
                        state
                    );
                },
            },
            RESOURCE_NAME: {
                columnId: 'RESOURCE_NAME',
                columnSQL: 'resource_name',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'resource_name',
                        state
                    );
                },
            },
            RESOURCE_PAYMENT_TYPE: {
                columnId: 'RESOURCE_PAYMENT_TYPE',
                columnSQL: 'resource_payment_type',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'resource_payment_type',
                        state
                    );
                },
            },
            RESOURCE_SOURCE_NAME: {
                columnId: 'RESOURCE_SOURCE_NAME',
                columnSQL: 'resource_source_name',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'resource_source_name',
                        state
                    );
                },
            },
            RESOURCE_SOURCE_CATEGORY: {
                columnId: 'RESOURCE_SOURCE_CATEGORY',
                columnSQL: 'resource_source_category',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'resource_source_category',
                        state
                    );
                },
            },
            CHANGE_TYPE: {
                columnId: 'CHANGE_TYPE',
                columnSQL: 'change_type',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'change_type',
                        state
                    );
                },
            },
            SEGMENT: {
                columnId: 'SEGMENT',
                columnSQL: '_NOT_IMPLEMENTED_',
                compileSQLTokens: segmentContainerIdCompileSQLTokens,
            },
            SEGMENT_EXCLUDE: {
                columnId: 'SEGMENT_EXCLUDE',
                columnSQL: 'segments',
                compileSQLTokens: segmentContainerIdCompileSQLTokens,
            },
        },
    };

    public static get sqlStatementsCompiler() {
        return new DatasourceSpecificColumnsSQLStatementsCompiler({
            sqlMap: BiVizDashboardResourcesSqlMap.sqlMap,
            specificColumns: [
                'RESOURCES_SOURCE',
                'RESOURCE_NAME',
                'RESOURCE_PAYMENT_TYPE',
                'RESOURCE_SOURCE_NAME',
                'RESOURCE_SOURCE_CATEGORY',
                'CHANGE_TYPE',
                'DECO_CONTEXT_RARITY',
                'DECO_CONTEXT_SIZE',
                'DECO_CONTEXT_SET_ID',
                'DECO_CONTEXT_INSPIRATIONS',
            ],
            datasourcePrefix: 'resources',
        });
    }

    public static readonly ALL_RESOURCES = [
        'energy',
        'gems',
        'hints',
        'coins',
        'compasses',
    ];
}
